import React from "react";
import { Link } from "react-router-dom";
import NoteGoogle from "./NoteGoogle";

/**
 * Bandeau de confiance.
 *
 * Ce composant affichait trois témoignages inventés — noms, âges, villes et
 * montants — présentés comme de vrais clients, sur l'accueil, la page
 * témoignages et les six pages départementales. Publier de faux avis de
 * consommateurs est une pratique commerciale trompeuse (art. L.121-2 et
 * L.121-4 11° du code de la consommation), passible de deux ans
 * d'emprisonnement et de 300 000 € d'amende, portés à 10 % du chiffre
 * d'affaires pour une société. Ils ont été retirés le 8 septembre 2026.
 *
 * Ce qui reste est vérifiable : la note Google, dont le composant renvoie à la
 * fiche publique, et les logos des organismes dont l'agrément est réel.
 *
 * Les vrais témoignages, recueillis par écrit et avec accord, prendront la
 * place du bloc « en cours de collecte ».
 */
const Testimonials = () => {
  return (
    <section id="temoignages" className="py-24 bg-gradient-to-br from-orange-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            Ce que disent nos bénéficiaires
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed mb-8">
            Témoignages en cours de collecte — contactez-nous pour en savoir plus.
          </p>

          <div className="flex justify-center mb-8">
            <NoteGoogle taille="grande" />
          </div>

          <Link
            to="/contact"
            className="inline-flex items-center min-h-[44px] px-6 py-3 border-2 border-orange-200 text-gray-900 font-bold rounded-lg hover:bg-orange-50 transition-colors"
          >
            Nous contacter
          </Link>
        </div>

        {/* Trust indicators */}
        <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg border border-gray-100">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ils nous font confiance
            </h3>
            <p className="text-gray-700">
              Nos certifications et partenaires en Île-de-France
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-12 items-center justify-items-center">
            <div className="text-center">
              <div className="w-32 h-24 bg-white rounded-lg shadow-md flex items-center justify-center mx-auto mb-4 p-3">
                <img 
                  src="/images/logo-anah.webp"
                  width="500"
                  height="430"
                  loading="lazy" 
                  alt="ANAH" 
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <p className="text-sm text-gray-700 font-medium">AMO Agréé</p>
            </div>
            
            <div className="text-center">
              <div className="w-32 h-24 bg-white rounded-lg shadow-md flex items-center justify-center mx-auto mb-4 p-3">
                <img 
                  src="/images/logo-france-renov.webp"
                  width="500"
                  height="285"
                  loading="lazy" 
                  alt="France Rénov'" 
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            </div>
            
            <div className="text-center">
              <div className="w-32 h-24 bg-white rounded-lg shadow-md flex items-center justify-center mx-auto mb-4 p-3">
                <img 
                  src="/images/logo-rge.webp"
                  width="1125"
                  height="750"
                  loading="lazy" 
                  alt="RGE" 
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <p className="text-sm text-gray-700 font-medium">Artisans labellisés</p>
            </div>
            
            <div className="text-center">
              <div className="w-32 h-24 bg-white rounded-lg shadow-md flex items-center justify-center mx-auto mb-4 p-3">
                <img 
                  src="/images/logo-idf.webp"
                  width="250"
                  height="167"
                  loading="lazy" 
                  alt="Île-de-France" 
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <p className="text-sm text-gray-700 font-medium">Spécialiste région</p>
            </div>
          </div>

          <div className="mt-12 grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-orange-700 mb-2">289</div>
              <p className="text-gray-700">Dossiers réalisés</p>
            </div>
            <div>
              <div className="text-3xl font-bold text-orange-700 mb-2">0 €</div>
              <p className="text-gray-700">Coût de l'AMO pour vous</p>
            </div>
            <div>
              {/* « 8M€ d'aides obtenues » était arithmétiquement impossible :
                  289 dossiers au plafond absolu de 15 400 € donnent 4,45 M€.
                  Remplacé par le taux, qui est une règle du dispositif, donc
                  vérifiable — à remplacer par le cumul réel s'il est connu. */}
              <div className="text-3xl font-bold text-orange-700 mb-2">70 %</div>
              <p className="text-gray-700">Des travaux financés au maximum</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;